import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

//localisation
import VueI18n from "vue-i18n";
Vue.use(VueI18n);
import { languages, defaultLocale } from './i18n/index.js';

const messages = Object.assign(languages);
const dateTimeFormats = {
    'nl' : {
        hes:{
            year: '2-digit', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', hour12: false
        }
    },
    'fr' : {
        hes:{
            year: '2-digit', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', hour12: false
        }
    },
    'en': {
        hes:{
            year: '2-digit', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', hour12: false
        }
    }
};
const i18n = new VueI18n({
    locale: defaultLocale,
    fallbackLocale: 'nl',
    messages,
    dateTimeFormats
});

import {library} from "@fortawesome/fontawesome-svg-core";
import {faTimes, faHiking, faBed, faTree, faEnvelopeOpenText, faBars} from "@fortawesome/free-solid-svg-icons";
import {faFacebookF} from "@fortawesome/free-brands-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

library.add(
    faTimes,
    faFacebookF,
    faHiking,
    faBed,
    faTree,
    faEnvelopeOpenText,
    faBars
);

Vue.component('fa-icon', FontAwesomeIcon);

import * as VueGoogleMaps from 'vue2-google-maps';

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyCv76XT8mfr-odUT4EC6Dt1FUO_GZWvnuw'
    }
})

import ApiService from "./services/api";
import {TokenService} from "./services/token";
import UserService from "./services/user";

ApiService.init(process.env.VUE_APP_ROOT_API);
if(TokenService.getToken()){
    ApiService.setHeader();
    ApiService.mount401Interceptor();
}
else{
    UserService.getToken();
}

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')
